import React, { useState, useEffect } from 'react';
import '../styles/styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import logo from '../components/images/logo.png';
import { ContenidoDinamico } from '../routes/AppRoutes';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const PaginaDocente = () => {
  const navigate = useNavigate();
  const location = useLocation(); // Obtenemos la ubicación actual de la URL

  // Obtener el nombre completo del alumno desde localStorage
  const nombreMostrar = localStorage.getItem('displayName') || 'Usuario'; // Mostrar el nombre completo del alumno o 'Usuario'

  const [submenuVisible, setSubmenuVisible] = useState(false); // Estado para controlar la visibilidad del submenú de sesión
  const [sidebarVisible, setSidebarVisible] = useState(false); // Estado para controlar la visibilidad del sidebar
  const [menusAbiertos, setMenusAbiertos] = useState({}); // Estado para manejar la visibilidad de otros submenús
  const [sessionMenuVisible, setSessionMenuVisible] = useState(false); // Estado para controlar la visibilidad del submenú de "Cerrar sesión"

  // Lógica para verificar que el usuario es un docente (rol 3)
  useEffect(() => {
    const userRole = Number(localStorage.getItem('role'));
    const token = localStorage.getItem('token');

    // Verifica si el rol es el adecuado y si hay un token de sesión
    if (userRole !== 3 || !token) {
      // Si no es un docente (rol 3) o no tiene sesión activa, redirige
      navigate('/login', { replace: true });
    }

    // Validar las rutas específicas del docente
    const allowedRoutes = [
      '/docente',
      '/docente/inicio',
      '/docente/registrar-planeaciones-docentes',
      '/docente/consultar-planeaciones-docentes',
      '/docente/registrar-evidencias-docentes',
      '/docente/consultar-evidencias-docentes',
      '/docente/registrar_calificacionxgrupo',  
      '/docente/consultar_calificaciones_paradocentes',
      '/docente/consultar_informacion_docente', // Nueva ruta para ver informacion personal del docente
      '/docente/consultar-docentehorariogeneral',
      '/docente/registrar-horarios-docente',
      '/docente/consultar_horario'
    ];

    if (!allowedRoutes.includes(location.pathname)) {
      // Si la ruta no es una de las permitidas para docente, redirigir al inicio
      navigate('/docente/inicio', { replace: true });
    }
  }, [navigate, location]);

  // Manejo del cierre de sesión
  const handleLogout = () => {
    // Eliminar las credenciales y otros datos del usuario
    localStorage.clear(); // Limpiar localStorage
    // Redirigir al inicio de sesión
    navigate('/login', { replace: true }); // Redirigir al login
  };

  // Función para alternar el submenú general
  const toggleSubmenu = (clave) => {
    setMenusAbiertos(prev => ({ ...prev, [clave]: !prev[clave] }));
  };

  // Función para alternar el submenú de sesión
  const toggleSessionMenu = () => {
    setSessionMenuVisible(!sessionMenuVisible);
  };

  // Lógica para obtener la clase correspondiente al submenú
  const getSubmenuClass = (clave) => menusAbiertos[clave] ? 'submenu-items d-flex flex-column' : 'submenu-items d-none';

  return (
    <div className="pagina-docente d-flex" style={{ height: '100vh', overflow: 'auto' }}>
      {/* Botón hamburguesa para móviles */}
      <button className="hamburger-btn d-md-none" onClick={() => setSidebarVisible(!sidebarVisible)}>
        <i className="fa fa-bars"></i>
      </button>

      {/* Panel lateral izquierdo */}
      <div className={`sidebar ${sidebarVisible ? 'active' : ''}`}>
        <div className="menu">
          <span className="titulo-left">Plataforma Digital Escolar</span>

          {/* Enlaces del menú */}
          <div className="submenu">
            <Link to="/docente/inicio" className="submenu-btn d-flex align-items-center gap-2" style={{ textDecoration: 'none', color: 'inherit' }}>
              <i className="fa fa-house"></i>
              <span>Inicio</span>
            </Link>
          </div>

          <button className="submenu-btn">
            <i className="fa fa-user"></i>
            <Link to="/docente/consultar_informacion_docente" style={{ all: 'unset', cursor: 'pointer' }}>
              Consultar Información
            </Link>
          </button>

          {/* Otros submenús como Planeaciones, Evidencias, etc. */}
          {/* Planeaciones */}
          <div className="submenu">
            <button className="submenu-btn" onClick={() => toggleSubmenu('planeaciones')}>
              <i className="fa fa-book"></i> <span>Planeaciones</span>
              <i className="fa fa-chevron-down arrow"></i>
            </button>
            <div className={getSubmenuClass('planeaciones')}>
              <Link to="/docente/registrar-planeaciones-docentes" className="submenu-btn"><i className="fa fa-pen"></i> Registrar Planeaciones</Link>
              <Link to="/docente/consultar-planeaciones-docentes" className="submenu-btn"><i className="fa fa-search"></i> Consultar Planeaciones</Link>
            </div>
          </div>

          {/* Evidencias */}
          <div className="submenu">
            <button className="submenu-btn" onClick={() => toggleSubmenu('evidencias')}>
              <i className="fa fa-book-open"></i> <span>Evidencias</span>
              <i className="fa fa-chevron-down arrow"></i>
            </button>
            <div className={getSubmenuClass('evidencias')}>
              <Link to="/docente/registrar-evidencias-docentes" className="submenu-btn"><i className="fa fa-pen"></i> Registrar Evidencias</Link>
              <Link to="/docente/consultar-evidencias-docentes" className="submenu-btn"><i className="fa fa-search"></i> Consultar Evidencias</Link>
            </div>
          </div>

          {/* Calificaciones */}
          <div className="submenu">
            <button className="submenu-btn" onClick={() => toggleSubmenu('calificaciones')}>
              <i className="fa fa-file-lines"></i> <span>Calificaciones</span>
              <i className="fa fa-chevron-down arrow"></i>
            </button>
            <div className={getSubmenuClass('calificaciones')}>
              <Link to="/docente/registrar_calificacionxgrupo" className="submenu-btn"><i className="fa fa-pen"></i> Registrar Calificaciones por Grupo</Link>
              <Link to="/docente/consultar_calificaciones_paradocentes" className="submenu-btn"><i className="fa fa-search"></i> Consultar Calificaciones</Link>
            </div>
          </div>

          {/* Horarios */}
          <div className="submenu">
            <button className="submenu-btn" onClick={() => toggleSubmenu('horarios')}>
              <i className="fa fa-file-lines"></i> <span>Horarios</span>
              <i className="fa fa-chevron-down arrow"></i>
            </button>
            <div className={getSubmenuClass('horarios')}>
              <Link to="/docente/registrar-horarios-docente" className="submenu-btn"><i className="fa fa-pen"></i> Registrar Horarios</Link>
              <Link to="/docente/consultar-docentehorariogeneral" className="submenu-btn"><i className="fa fa-search"></i> Consultar su Horario</Link>
            </div>
          </div>
        </div>
      </div>

      {/* Panel principal: topbar + contenido dinámico */}
      <div className="d-flex flex-column flex-grow-1">
        {/* Topbar */}
        <div className="topbar d-flex justify-content-between align-items-center px-4 py-2">
          <span className="titulo-top d-flex align-items-center">
            <img src={logo} alt="Logo del Instituto" width="30" height="30" className="me-2" />
            Instituto Silviano Carrillo
          </span>

          {/* Submenú sesión */}
          <div className="submenu">
            <button className="submenu-btn btn-sesion" onClick={toggleSessionMenu}>
              <i className="fa fa-user"></i>
              <span>{nombreMostrar}</span>
              <i className="fa fa-chevron-down arrow"></i>
            </button>

            {/* Submenú con "Cerrar sesión" */}
            {sessionMenuVisible && (
              <div
                style={{
                  display: "block",
                  position: "absolute",
                  top: "100%",       // debajo del botón
                  right: "0",        // alineado a la derecha
                  backgroundColor: "#ffffff",
                  boxShadow: "0 4px 12px rgba(7, 152, 249, 0.15)",
                  borderRadius: "8px",
                  minWidth: "180px",
                  zIndex: 1000,
                }}
              >
                <button
                  onClick={handleLogout}
                  style={{
                    padding: "10px 16px",
                    color: "#1976d2",
                    border: "none",
                    background: "none",
                    fontSize: "14px",
                    width: "100%",
                    textAlign: "left",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                  onMouseOver={e => (e.currentTarget.style.backgroundColor = "#67c6ff")}
                  onMouseOut={e => (e.currentTarget.style.backgroundColor = "transparent")}
                >
                  <i className="fa fa-right-from-bracket"></i>
                  <span>Cerrar sesión</span>
                </button>
              </div>
            )}

          </div>
        </div>

        {/* Contenido dinámico */}
        <main className="contenido-principal flex-grow-1 p-4" id="contenido-dinamico">
          <ContenidoDinamico />
        </main>
      </div>
    </div>
  );
};

export default PaginaDocente;
